<template>
  <Fieldset
    :legend="legend"
    :toggleable="toggleable"
    :collapsed="collapsed"
    v-bind="$attrs"
  >
    <template v-if="$slots.legend" #legend>
      <slot name="legend" />
    </template>
    <slot />
  </Fieldset>
</template>

<script setup lang="ts">
import Fieldset from 'primevue/fieldset';

withDefaults(defineProps<{
  legend?: string;
  toggleable?: boolean;
  collapsed?: boolean;
}>(), {
  legend: '',
  toggleable: false,
  collapsed: false
});
</script>
